import { l } from '../lib/imports'

export type ModelActorType = 'o2gen' | 'co2scrubber' | 'human' | 'leak'

export interface IModelSpot {
  i: number
  j: number
  o2: number
  co2: number
  o2next: number
  co2next: number
  isSpace: boolean
  isHull: boolean
  buildingNum: number
  // isOxyGen: boolean
  // isCo2Scrub: boolean
}

export interface IModelSpotUpdate {
  isSpace: boolean
  isHull: boolean
}

// Human consumers, leaks?
export interface IModelActor {
  i: number
  j: number
  type: ModelActorType
  setPoint?: number
}

export interface IOxygenModel {
  width: number
  height: number
  spots: IModelSpot[]
  actors: IModelActor[]
}

export function createSpot(i: number, j: number): IModelSpot {
  return {
    i,
    j,
    o2: 0,
    co2: 0,
    o2next: 0,
    co2next: 0,
    isSpace: true,
    isHull: false,
    buildingNum: 0,
    // isOxyGen: false,
    // isCo2Scrub: false,
  }
}

export function createModel(width: number, height: number): IOxygenModel {
  let obj: IOxygenModel = {
    spots: [],
    actors: [],
    width,
    height,
  }

  for (let j = 0; j < obj.height; j++) {
    for (let i = 0; i < obj.width; i++) {
      let t = createSpot(i, j)
      obj.spots.push(t)
    }
  }

  return obj
}

export function getTile(map: IOxygenModel, tx: number, ty: number) {
  if (!inRange(map, tx, ty)) {
    return null
  }
  return map.spots[ty * map.width + tx]
}

export function getTileUnsafe(map: IOxygenModel, tx: number, ty: number) {
  if (!inRange(map, tx, ty)) {
    throw new Error(`out of range! ${tx} {$ty}`)
  }
  return map.spots[ty * map.width + tx]
}
export function inRange(map: IOxygenModel, tx: number, ty: number) {
  if (tx >= 0 && tx < map.width) {
    if (ty >= 0 && ty < map.height) {
      return true
    }
  }
  return false
}

export function setModelActors(map: IOxygenModel, actors: IModelActor[]) {
  map.actors = actors
}
export function syncGrid(map: IOxygenModel, spotSyncs: IModelSpotUpdate[]) {
  for (let i = 0; i < map.spots.length; i++) {
    map.spots[i].isSpace = spotSyncs[i].isSpace
    map.spots[i].isHull = spotSyncs[i].isHull
  }
}

// TODO: update
// TODO: set actors
